import api from "@/api.js";

export default {
  namespaced: true,
  modules: {},
  state: {
    list: [],
    listLoading: false,
    current: null,
    currentLoading: false,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setCurrent(state, payload) {
      state.current = payload;
    },

    setCurrentLoading(state, payload) {
      state.currentLoading = payload;
    },
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("basicGoals");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadAllByOutcomeID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("basicGoals/byOutcomesID", {
        params: { id: id },
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadByID({ commit }, id) {
      commit("setCurrentLoading", true);
      let response = await api.get("basicGoals/byID", {
        params: { id: id },
      });
      commit("setCurrent", response.data[0]);
      commit("setCurrentLoading", false);
    },
    async loadBySourceID({ commit }, id) {
      commit("setCurrentLoading", true);
      let list = await api.get("basicGoals/bySourcesID", {
        params: { id: id },
      });
      commit("setCurrent", list.data[0]);
      commit("setCurrentLoading", false);
    },
    async loadBySourceIDWithStatusLive({ commit }, id) {
      commit("setCurrentLoading", true);
      let list = await api.get("basicGoals/bySourcesID/withStatusLive", {
        params: { id: id },
      });
      commit("setCurrent", list.data[0]);
      commit("setCurrentLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("basicGoals", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};

      //uploading image
      if (payload.basicGoalImage) {
        let uploadImageResult = await api.post(
          "basicGoals/uploadBasicGoalImage",
          {
            id: payload.id,
            imageData: payload.basicGoalImage.dataUrl,
          }
        );
        delete payload.basicGoalImage;
        if (uploadImageResult.data.Result == "Success") {
          payload.basicGoalImageUrl = uploadImageResult.data.objectUrl;
        }
      }
      await api
        .put(`basicGoals`, payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async addOutcome({ dispatch }, payload) {
      let returnData = {};

      await api
        .post(`basicGoals/outcome`, payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadAll");
      dispatch("loadByID", payload.basicGoals_id);
      return returnData;
    },
    async saveOutcome({ dispatch }, payload) {
      let returnData = {};

      await api
        .put(`basicGoals/outcome`, payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadAll");
      dispatch("loadByID", payload.basicGoals_id);
      return returnData;
    },

    async addSolution({ dispatch }, payload) {
      let returnData = {};

      await api
        .post(`basicGoals/solution`, payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadAll");
      dispatch("loadByID", payload.basicGoals_id);
      return returnData;
    },
    async saveSolution({ dispatch }, payload) {
      let returnData = {};

      await api
        .put(`basicGoals/solution`, payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadAll");
      dispatch("loadByID", payload.basicGoals_id);
      return returnData;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    current(state) {
      return state.current;
    },
    currentLoading(state) {
      return state.currentLoading;
    },
  },
};
